import { render, staticRenderFns } from "./BtnUpDown.vue?vue&type=template&id=0679f67b&scoped=true&lang=pug&"
import script from "./BtnUpDown.vue?vue&type=script&lang=js&"
export * from "./BtnUpDown.vue?vue&type=script&lang=js&"
import style0 from "./BtnUpDown.vue?vue&type=style&index=0&id=0679f67b&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0679f67b",
  null
  
)

export default component.exports